import {
  HOME_PAGE_URL,
  ABOUT_ME_PAGE_URL,
  GALLERY_PAGE_URL,
  CONTACT_PAGE_URL,
  SERVICES_PAGE_URL,
} from '../Constants';

export const FooterLinksArray = [
  {
    name: 'Home',
    route: HOME_PAGE_URL,
  },
  {
    name: 'About Me',
    route: ABOUT_ME_PAGE_URL,
  },
  {
    name: 'Gallery',
    route: GALLERY_PAGE_URL,
  },
  {
    name: 'Services',
    route: SERVICES_PAGE_URL,
  },
  {
    name: 'Contact Me',
    route: CONTACT_PAGE_URL,
  },
];
